// extracted by mini-css-extract-plugin
export default {"root":"DotDivider-root-6ca18efba13ab7e4aa6c18a2ea661cf4"};